/* unplugin-vue-components disabled */import script from "./SubItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubItem.vue?vue&type=script&setup=true&lang=js"

import "./SubItem.vue?vue&type=style&index=0&id=2385a2e8&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2385a2e8"]])

export default __exports__